import { Component, EventEmitter, Output } from '@angular/core';
import { ICON } from '@core/util/icon';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';
import { NavigationService } from '@services/nav/nav.service';
import { SelectedMatterDocumentsDispatch } from '@state/global/documents/selected-matter-documents.dispatch';
import { SelectedMatter } from '@state/matter/matter.selectors';
import {
	RecentlyViewedDocument,
	RecentlyViewedSelector,
} from '@state/recently-viewed/recently-viewed.selector';
import { Observable } from 'rxjs';
import { TestHooks } from './document-drop-down.hooks';

@Component({
	selector: 'app-document-drop-down',
	templateUrl: './document-drop-down.component.html',
	styleUrls: ['./document-drop-down.component.scss'],
	standalone: false,
})
export class DocumentDropDownComponent {
	testHooks = TestHooks;
	public ICON = ICON;
	public searchValue = '';

	@Output() onDocumentSelected: EventEmitter<boolean> = new EventEmitter();
	@Output() onMouseOver: EventEmitter<boolean> = new EventEmitter();
	@Output() onMouseOut: EventEmitter<boolean> = new EventEmitter();

	@Select(RecentlyViewedSelector.getMatterViewedDocs)
	public viewedDocuments$: Observable<RecentlyViewedDocument[]>;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		private navService: NavigationService,
		private selectedMatterDocumentDispatch: SelectedMatterDocumentsDispatch,
		private analytics: AnalyticsService,
	) {}

	trackById(index, document) {
		return document.id;
	}

	goToDocument(id: string) {
		this.analytics.logEvent(
			AnalyticsEvent.TOP_NAV_BAR_DROPDOWN_DOCUMENT_CLICK,
			{ documentId: id },
		);
		this.navService.goToMatter_Documents_Doc(this.matterId, id);
		this.selectedMatterDocumentDispatch.SelectedDocuments([id]);
		this.onDocumentSelected.emit();
	}

	clearSearch() {
		this.searchValue = '';
	}

	documentsMouseover() {
		this.onMouseOver.emit();
	}

	documentsMouseout() {
		this.onMouseOut.emit();
	}
}
